import React, { useEffect } from 'react';
import './About.css';

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const locations = [
    {
      city: 'Palanpur',
      address: 'Abu Road Highway, Near Gayatri Temple, Tirupati Rajnagar, Palanpur, Gujarat 385001',
      pincode: '385001'
    },
    {
      city: 'Deesa',
      address: 'Deesa- Palanpur Highway, Deesa 385535',
      pincode: '385535'
    },
    {
      city: 'Patan',
      address: 'Patan–Unjha Highway, Near Hansapur, Patan – 384265',
      pincode: '384265'
    }
  ];

  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="container">
          <div className="about-hero-content">
            <h1 className="about-title">Our Locations</h1>
            <p className="about-subtitle">Visit us at any of our authorized showrooms across Gujarat</p>
          </div>
        </div>
      </section>

      <section className="about-intro">
        <div className="container">
          <div className="about-intro-content">
            <h2 className="intro-title">About SHUBH HYUNDAI</h2>
            <p className="intro-description">
              As an authorized Hyundai dealership, SHUBH HYUNDAI brings you the assurance of genuine products, 
              certified service, and unwavering commitment to excellence. With multiple locations across Gujarat, 
              we are dedicated to providing premium automotive solutions to our valued customers.
            </p>
            <p className="intro-description">
              Our legacy is built on trust, quality, and customer satisfaction. We offer comprehensive 
              automotive services including vehicle sales, authorized service, and genuine spare parts, 
              all backed by Hyundai's world-class standards.
            </p>
          </div>
        </div>
      </section>

      <section className="locations-section">
        <div className="container">
          <div className="locations-grid">
            {locations && locations.length > 0 && locations.map((location, index) => (
              <div key={index} className="location-card">
                <div className="location-icon">
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                    <path d="M16 2C11.5817 2 8 5.58172 8 10C8 16 16 30 16 30C16 30 24 16 24 10C24 5.58172 20.4183 2 16 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <circle cx="16" cy="10" r="3" stroke="currentColor" strokeWidth="2"/>
                  </svg>
                </div>
                <h3 className="location-city">{location.city}</h3>
                <p className="location-address">{location.address}</p>
                <div className="location-actions">
                  <a href={`tel:+917575808003`} className="location-btn">Call Now</a>
                  <a 
                    href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(location.address)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="location-btn secondary"
                  >
                    Get Directions
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="about-trust">
        <div className="container">
          <div className="about-trust-content">
            <h2 className="trust-section-title">Why Choose SHUBH HYUNDAI?</h2>
            <div className="trust-features-grid">
              <div className="trust-feature-item">
                <div className="trust-feature-icon">
                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <path d="M20 2L4 10V20C4 28.5 8.5 36.5 16 40.5L20 43.5L24 40.5C31.5 36.5 36 28.5 36 20V10L20 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M20 14V24M20 14L14 18M20 14L26 18M20 24L14 28M20 24L26 28" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <h3>Authorized Dealership</h3>
                <p>Official Hyundai partner with certified standards</p>
              </div>
              <div className="trust-feature-item">
                <div className="trust-feature-icon">
                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <path d="M20 4L8 12V20C8 26.5 11.5 32.5 17 36L20 38L23 36C28.5 32.5 32 26.5 32 20V12L20 4Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 20L18 22L24 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <h3>Genuine Parts</h3>
                <p>100% authentic Hyundai spare parts</p>
              </div>
              <div className="trust-feature-item">
                <div className="trust-feature-icon">
                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <circle cx="20" cy="20" r="16" stroke="currentColor" strokeWidth="2"/>
                    <path d="M20 12V20L26 24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <h3>Expert Service</h3>
                <p>Certified technicians and modern facilities</p>
              </div>
              <div className="trust-feature-item">
                <div className="trust-feature-icon">
                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <path d="M20 8L12 14V22C12 27.5 15 32.5 19.5 35.5L20 36L20.5 35.5C25 32.5 28 27.5 28 22V14L20 8Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 22L18 24L24 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <h3>Customer First</h3>
                <p>Dedicated support and satisfaction guarantee</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;

